import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { SecurityAlertComponent } from '../components/security-alert/security-alert.component';
import { MatDialog } from '@angular/material/dialog';

export const SKIP_SECURITY_ALERT_HEADER = 'X-Skip-Security-Alert';

@Injectable()
export class HttpSecurityInterceptor implements HttpInterceptor {

  constructor(protected dialog:MatDialog) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(tap((event: HttpEvent<any>) => { return event }, (error: HttpErrorResponse) => {

      if (request.headers.has(SKIP_SECURITY_ALERT_HEADER)) {
        return error
      }

      if (error.status >= 400 && error.status < 500) {
        console.log("----response----");
        console.error("status code:");
        console.error(error.status);
        console.error(error.message);
        console.log("--- end of response---");
        setTimeout(() => {
          this.dialog.open(SecurityAlertComponent, {
            position: { top: "40px" },
            hasBackdrop: true,
            panelClass: "no-dialog-borders",
            disableClose: true,
            data: { code: error.status  } 
          })
        }, 10)
      }
	  
      // http response status code
      return error

    }));
  }
}
